<template>
  <div class="page">
    <div class="center m-t-10 m-b-10"><img src="@/assets/images/home-title.png">
    </div>

    <div class="total-view w">
      <div class="el-row" style="margin-left: -10px; margin-right: -10px;">
        <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px;">
          <div class="total-item">
            <div class="icon m-b-5"><img
                class="m-r-10"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAMAAACKeiw+AAABMlBMVEUAAABEREQhif8wa61EREREREQ5OTlERERERERVVVVERERDQ0NERERDQ0NFRUVERERAQEBFRUVERERDQ0NEREREREQhif9ERERERERERERERERDQ0NEREREREREREQhiv9EREQhif9DQ0NERERNTU1ERERCQkJFRUVERERGRkZDQ0NFRUVFRUVERERHR0dDQ0NERERDQ0NERERFRUVERERVVVVERERAQEBCQkJFRUVERERDQ0MsetNEREQ6V3hEREQlgusiiv8fi/9DQ0NAQECAgIBBQUE7V3cAgP8jjf8zZp8ucLwgif8hif8hif9DQ0NCQkJFRUUiif8ji/8hiP9HR0dJSUkhif8xaakgiv9GRkYiiP8iif9ERERDQ0Miiv8kiv9JSUkgif9EREQhiP9FRUWIYVodAAAAZnRSTlMA/////esJ+vcDcN/zYlGXELqeSNvh4XzuhORBj12tzsR1TA8KeRu1zRakM0OREr4tm8jJUAZHCDZ53T0Xz/9//5hROQQCK+cCHf/dtdnvjDJoWyyhJA77/35C1b7XE2IjFaZsuaCzgz6iAAABS0lEQVR4nHWT13qCQBhEd8wiqIi9m1hiN9FYYkvvvffe3/8VAooILJ6rgcM3y/4LREf1L06FtQ2v/p7G7iJGRANWugLq6dlrUhPUws+C7wyDwwOO7Q/CqSZHCxGz3Ye4PM4SSmYtwaflMkR26aKWc4BZJzDQ8g5CZm0XkRjnBvzMmycR/BqlLKWXjPYOEFxQavo8kowl5G4AuIp1EfA7WDvfj6szR73NWDcHcJW8+yrm44H0kkHm5oBSW+2s5aMQ3PriJoQf3fW7/PRk7PY0uJ5xrQi0EyJ+RI1ryThBlW3KSKDawCY0EL8fVocQYy3pvo2m44Sra6HJM/gCIXsu6Dehw6e0roCTP5PDm+un29fUWTj8kvrdymwfyTqrnOsFPJ+Z03ObifD3xyqHMmnhxKxUHg5QJQI2p2jbIzqyPp6ZwjoCZPzrWMEX/gGEnh45Z6OzqAAAAABJRU5ErkJggg=="><span
                class="label">专家</span></div>
            <div><span class="value">514</span><span
                class="unit"> 位 </span></div>
          </div>
        </div>
        <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px;">
          <div class="total-item">
            <div class="icon m-b-5"><img
                class="m-r-10"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAYAAABvCO8sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE82lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTEyLTE0VDA5OjI0OjE5KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0xMi0xNFQxMToxMTowNyswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMS0xMi0xNFQxMToxMTowNyswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ZWI3OGUzOTktYTg0Mi03NTRkLWIxMDYtMjU4NGZiYzljYzBkIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOmViNzhlMzk5LWE4NDItNzU0ZC1iMTA2LTI1ODRmYmM5Y2MwZCIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOmViNzhlMzk5LWE4NDItNzU0ZC1iMTA2LTI1ODRmYmM5Y2MwZCI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6ZWI3OGUzOTktYTg0Mi03NTRkLWIxMDYtMjU4NGZiYzljYzBkIiBzdEV2dDp3aGVuPSIyMDIxLTEyLTE0VDA5OjI0OjE5KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Ir1MbgAAA7BJREFUSIm9ln9MU1cUx7/3lWnA9W1mLogQp2UTMEwNlRiXEXC//sGCOhPzGuh0iw8TiUbLxtQpqNvc5thk5Q8tiZrGQbIgmHarGc5MsoRQQ000guB/hBb9S9tXZWUZOf6BffTSvvbNLJ7k/vHePed8zjnvvnsOIyI8T8nQqxgITlCrw4nuS79y77fbJOytlyGKRqbHD0uXoaJE6JyrEz+1OTmIokRUuCgasd0mYYdNSg8moqQrHFbolOMMrSmtIFOBmUwFZmpobKLxQJBiOuOBIEk1O9X9NaUVdLHHQ1o+iSg5sKvbTWUbLKojqWYnDQ2Pajoa8A1y4LINFk0w99B75c8E0IBvkDP0BojMXqJdPqKJSaKU9rVygv1shLUyF2FXt5tTHHtEZOsnwoXZNb+T6MQQJWSSUKFaWa0Qa2hsoviT98WB/djxkZX78N8Mg5pvAVPTyc/BG0bgyJtAzXKodooSodY2J867OlW9t99aBxYOK9wpFEUjDh+0Y8umjexyEHT4FuB/kPLcqfLOYuBIMVCeDXaxx0NHj5/E48lJTkf9LfIL13L/x8uFZtwus+OfxSv00Z7KvPt3UfxXC0IjfvVd31U3yt+tAgAIcw2+O9GEF7JeRGjEj7x2K17p/QFCNJIWJEQjeNV9FHntVoRG/MhclKPu5eUuYQuyspIDP9xsYdevefD+VgkA8JKvA0sdVVgwek0TFtMx3vQAALZ8LKPf28EHZBCSAwFAFI3s9Jd25unpQPbKEgjRCLJ/aUCOqw4ZoQlVL3OMr0JucQn6rrpx8jOZad04Ke/SlUUrWH+3E9+6PNT+Ywsyx/xY6qjCw3IZGaF7akaZi3Jw6IAdUmWF5rXGGNPOcK402izsRp8Hr1dsBAAs7HOqsA9qZ8qXCgYAwlOg7m4hikb2++lmuP6w0LF9e2AQBFy+dAGm5a/p6xKpvmEqsb1nZvMEwr9TfyN3SU56gznyn4HPKg8fhJ4vMCYJQN91//8ycwzfucv5yTctQ75p2SxwXWkJAMBqq8OnnzeTokSeGdza5iTLZisAoKhw5mrs9XaxXm8XS2grq9eWp+3eRavWk6nATNHoFLc/Hghybe6U40yCfdLR4thX33O9LH6s0AKePf+zOo5UVkuaE4Lm7DE0PEqV1VLSaOOB4bBCdbvtKbPSBYyPPFbmymqJBnyDFAP+5r2iK6v4lXZMBGa69/GvW9Sx0GAwYHp6tv3vqZext17WdeOkzXDudBZf5m3WT3RlFb+eANRCjuTV4W7PAAAAAElFTkSuQmCC"><span
                class="label">团队</span></div>
            <div><span class="value">8</span><span
                class="unit"> 个 </span></div>
          </div>
        </div>
        <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px;">
          <div class="total-item">
            <div class="icon m-b-5"><img
                class="m-r-10"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAMAAACKeiw+AAABmFBMVEUAAABEREQVdP9DQ0NEREREREQAAABVVVVEREQQj99EREQYcfNERERERERERERDQ0MWc/tEREVCRk5ERERERERFRUVFRUVDQ0MAAP8ab+lERERERERDQ0NERERERERERERHR0dAQEBGRkZERERERERERERERERDQ0NEREQXc/8VdP+AgIBDRUghaM4VdP89TGBCQkJAQEAtXaMUdP9BQUEVdP8Vdf9ERERBR1BAQEBEREREREREREREREQVdf9ERERJSUkrX6tFRUVFRUUVdP8gadNEREQUdv88TWVNTU1GRkZDQ0NFRUVLS0tERERERERFRUVFRUVFRUVGRkZDQ0NEREQ0VYU5OTlAQEAVdP8bbudJSUkAVf9DSEsScv8cbuMWdf8AgP88TGREREQ1VIIQcP8Uc/9EREQkbf9GRkYVdf8Sc/9AQEAVdP9GRkZCQkIVdP9ERERDQ0NFRUUVc/9ERERERERCRkkVc/9GRkYXdP87OztEREREREQab+0Rd/9AQEBCQkI8TmhBQUFFRUVAQEBFRUVERETW7Ir2AAAAiHRSTlMA//8ugP0BA/kQ6f/7vKTB/+z+9y1jROAB//TUrYSz3BIQKMV9p7BanUSuAv//2f82GP/JK+t6D9sMZjlvS5l4Dv8xYP3/tw3/CgtHoRFz2GgaTjMX5v8JHPV9BwNjHW2MBoBs/xBbjgchVSoEhhYj9OITO5SS8WmzNywNiMD/HhQfgCe6CD+WU44pJgAAAdVJREFUeJyNkuVDG0EQxd8b7i7XiwsQAUISgrsVihWKFS0t1N29pe4u/3Z34/Klvy+7c+9m3+zs4D9wpRsUkf18tB/RUdpVkmeZwzOjg2FPPtopyXNk1jA+8/Ab0H5Iv2H4yNPl01fpt5BKctWy2tjcDnjprTB/ZrMLOGNzYYeeYaCL9s/K4gw6R4FbND2cBY4fsLWq9t9JvlZLC9lpAffYfLL6bnM0l1SaL6sOaTAr68rTwozK01gZttW15nucx/K7Eww/qG/dAoPqRsC2w456FZfe8JReGxmvqStHB+1xvabDNOrVP6ZKvvxk/o5KN5tq1acHzALXRd5F4aMzUq32/WLyIx6KYhLTu/SWn7NgvIRHzyUWk+UeRGrsm0x16bVBWenvX5GJq8qeFfYjDn2I9kpgnVwPyNgNbNHZK6ouL3enMSmyyFCIiyKvsJGgv2hvMBxBz7J8CfHmD4ZiIncxHi++6abJRnydEDnLKVffFG+LXPigOs9Nre453ML9MZEB8r0aGXJAZHAN3QyeV8Z+JjYwLxIYYrf+/S+HAiK90XMJZh6jlfbL1DW32z3K4Astbwc5qsKLqRmbn1CYas3bIzmulL+Y6Czt9ZRpLDVxBeqnppp/F9I3usM4hBAAAAAASUVORK5CYII="><span
                class="label">专利</span></div>
            <div><span class="value">5695</span><span
                class="unit"> 个 </span>
            </div>
          </div>
        </div>
        <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px;">
          <div class="total-item">
            <div class="icon m-b-5"><img
                class="m-r-10"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAMAAAAFBf7qAAABCFBMVEUAAABERERDQ0NEREREREQhif9ERERERERAQEBERERFRUUhif1ERERDQ0NVVVVERERERERVVVVERERDQ0NEREQ5OTlAQEBFRUVERERFRUVERERFRUVEREREREQ/TV1DQ0M2YJFERERHR0cyaKZERERATFlEREREREQ8VG9ERERERERFRUUzZZ9ERERGRkZCR01BQUFDQ0M9UWdFRUVDQ0NERERGRkZNTU1ERERERERERERERERFRUVGRkY9UmlFRUUsdMYzMzMsc8NERERDQ0NEREQtcsBDQ0NGRkZERERERERLS0s/TmBERERDQ0NEREQ+UGVERERAQEBDQ0NERERDQ0NERERFRUXF/emYAAAAWHRSTlMA/y5w8P/z+gT1RP/9YwbhqgPHE4cJCE51jetZR9r6I/5pGf/4+HKz/Oijiv9KHPwrvf933ykWCtZtrcp6LP1r/wX/e1+P/0ELzlYR/C1FlfveDBceKrBv4AJVQwAAAUJJREFUeJytkVdiwjAQRDUUywZsCL3XEHpPQiekkN7r/W+SFWDANp/Mh7Srt5JGWsZY2yfBJGk0JcDuFEBxGESliosxuYJqU5TsKl9FXGZNjI/0FVneQD++WRvXetqQlIgeRzFlNtjXmeYFKuF1YodtiwITPL9jErCgvzh5vr2iIX5iRE8etGYFp7MwawFi4xb1JWSdS2WhfBoPjHDUBamDL13u2kigKFARCYtDF8ru+dxdRtKCLtBNA+kulgYN6IZ8ez9oUC1IDnaGmpbrxC6tv2HUYVBtsWmdCQWB2H6kgnPk9iEXh6rC07CiMwdq4kzJZkbnpxiJ2QdvXkcv6FEU8mPcF0sUPNzTHCWUQWlV/LW6hLaX6Am/yLDwMXraAo4f3TZd+haOgodEN0j8dfsRZJU0FOFjCoNV/9ZKDpCiXv8DKYMa29b/pO8AAAAASUVORK5CYII="><span
                class="label">软著</span></div>
            <div><span class="value">1132</span><span
                class="unit"> 个 </span></div>
          </div>
        </div>
        <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px;">
          <div class="total-item">
            <div class="icon m-b-5"><img
                class="m-r-10"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAfCAMAAAAhm0ZxAAAAolBMVEUAAABERERERERDQ0Mhif9AQEBERERERERISEhFRUVFRUVCSE8jhfMvbbJERERERERERERVVVVEREQ5OTlFRUWAgIBERERERERFRUVERERERERERERERERERERDQ0NDQ0NEREQyaKZFRUVJSUlCQkJDQ0NFRUVERERERERJSUlERERFRUVGRkZERERNTU1ERERHR0dERERERERFRUVFRUVVVVVlYmtUAAAANnRSTlMA//DQ/xCwaSCgYP////75yAPeCasCLZvT8Yq/D9iNTOD/egcbF121QBXvVTfPClMSMR5+WQYYECyEAAAAyElEQVR4nK3T1w6CMBiG4f8vKk6QIRvce6/7vzWZLcXCgfE9InkS+qUEaG4iSypWUnQvSMisQla4B5CRHN9fLzs5aAI4eBWdtFIVAEXVhDN8BEAintgp7NVj2RZvYXmhx5vVZ21uvDWd96tFEus85W1c3rngzeiyHn/aorWTlsVD0rYwPx3hrrlRudkHEicFQHCQR41GcNhKG9VbTHKNZSS0nERWEKBaNUqg4443RvDE2b1sc0ZgxFeh04+nxPdBCeASudxvQukDJeMLtWiiPqAAAAAASUVORK5CYII="><span
                class="label">需求</span></div>
            <div><span class="value">237</span><span
                class="unit"> 条 </span>
            </div>
          </div>
        </div>
        <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px;">
          <div class="total-item">
            <div class="icon m-b-5"><img
                class="m-r-10"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAMAAADDR10IAAAAilBMVEUAAABEREQhif9EREREREREREQAAABISEhDQ0NFRUVCSE9EREQ1YpUjhfNVVVVERERERERDQ0NFRUVERERERERGRkZCQkJFRUVAQEBDRkhAQEBFRUVVVVVDQ0NERERJSUlCQkJERERERERFRUVHR0dNTU1CSE5ERERDQ0NFRUVERERERERGRkZCQkKp685/AAAALnRSTlMA///wKYABINAw/3D//wbt+4HEu/M+H5EQ/wRkAy5WDhue2UokCv+XE8n3HkIj96Y7tQAAAItJREFUeJzt0UcSwjAQRNFuTDJBciLnnO9/PSwwRiXNgg2s+Mt5VQo1mMaaUlESArFIJq2gOUdewG6lqMN2PhgmvIE05iNqrH4d962ikYcn+xMbB8f9RtnxMbHQ74+/wWX4aqZcvETvda5cXKTNsslnd2a8iqZSbjEgA6kzsx3UwXqK3br3PKIuZOZ3aAQJCNhOvl4AAAAASUVORK5CYII="><span
                class="label">产业</span></div>
            <div><span class="value">4</span><span
                class="unit"> 个 </span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.page {

  padding: 40px 0;

  .total-view {

    .total-item {

      display: flex;
      flex-direction: column;
      text-align: center;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      padding: 15px 10px;
      margin-bottom: 20px;
      border-radius: 8px;

      .icon {
        img {
          transform: scale(.9);
        }
      }

      .value {
        font-size: 28px;
        color: #0076f6;
      }

      .unit {
        font-size: 14px;
        color: #999;
        margin-left: 5px;
      }
    }
  }
}


.m-b-5 {
  margin-bottom: 5px;
}

.center {
  text-align: center;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-t-10 {
  margin-top: 10px;
}

div {
  box-sizing: border-box;
}

img {
  vertical-align: middle;
}

img {
  border: none;
}
</style>